import './toast.scss';
import React, { useEffect, useState, memo, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Icon, useTheme } from '..';
const Toast = _ref => {
  let {
    customElement,
    error,
    image,
    linkTitle,
    onClick,
    onClose,
    subtitle,
    timeout,
    title
  } = _ref;
  const {
    theme
  } = useTheme();
  const [unmount, setUnmount] = useState(false);
  const timeoutRef = useRef(null);
  useEffect(() => {
    if (timeout) {
      timeoutRef.current = setTimeout(() => {
        setUnmount(true);
        closeMessage();
      }, timeout);
    }
    return () => {
      stopTimer();
    };
  }, []);
  const closeMessage = () => {
    if (onClose) setTimeout(() => {
      onClose();
    }, 250);
  };
  const stopTimer = () => {
    if (timeout) clearTimeout(timeoutRef.current);
  };
  const resumeTimer = () => {
    if (timeout) timeoutRef.current = setTimeout(() => {
      setUnmount(true);
      closeMessage();
    }, timeout);
  };
  const handleClose = () => {
    setUnmount(true);
    closeMessage();
  };
  return /*#__PURE__*/React.createElement("div", {
    onMouseEnter: stopTimer,
    onMouseLeave: resumeTimer,
    className: classNames('wrts-toast', theme, {
      unmount,
      clickable: !!onClick
    }),
    onClick: () => {
      if (onClick) {
        onClick();
        handleClose();
      }
    }
  }, customElement && customElement, image ? /*#__PURE__*/React.createElement("img", {
    src: image,
    className: "img",
    alt: "illustration",
    width: 64
  }) : /*#__PURE__*/React.createElement(Icon, {
    name: error ? 'incorrect' : 'correct'
  }), /*#__PURE__*/React.createElement("div", {
    className: "wrts-toast-info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "main-text"
  }, title), subtitle && /*#__PURE__*/React.createElement("span", {
    className: "sub-text"
  }, subtitle), linkTitle && /*#__PURE__*/React.createElement(Button, {
    type: "simple-link purple link",
    title: linkTitle
  })), /*#__PURE__*/React.createElement(Button, {
    iconName: "close",
    onClick: e => {
      e.stopPropagation();
      handleClose();
    },
    type: "icon-link",
    className: "wrts-toast-close-btn"
  }));
};
Toast.propTypes = {
  customElement: PropTypes.node,
  error: PropTypes.bool,
  image: PropTypes.string,
  linkTitle: PropTypes.string,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  subtitle: PropTypes.string,
  timeout: PropTypes.string,
  title: PropTypes.string
};
export default /*#__PURE__*/memo(Toast);